/**
 * Major units from the model's cents, for code that still takes major units.
 * Every such mapping goes through these helpers, so their usages list the
 * places to move to cents.
 */
export function centsToMajor(cents: number): number;
export function centsToMajor(cents: number | undefined): number | undefined;
export function centsToMajor(cents: number | undefined) {
  return cents === undefined ? undefined : cents / 100;
}

/** Every amount of a record of cents in major units. */
export function centsRecordToMajor(record: Record<string, number>) {
  return Object.fromEntries(
    Object.entries(record).map(([key, cents]) => [key, centsToMajor(cents)]),
  );
}
